export const BusinessCount: TAnt.TableColumnRender<number> = (count) => (
  <>{count > 0 ? count : ''}</>
)
